import classes from "./Vienna_slide.module.css";
import MediaS from "../MediaS";
import AddMedia from "../AddMedia";
import ModalView from "../Modal/ModalView";
import {useEffect, useState} from "react";
import logo from "../../../store/logo.png";
import axios from "axios";
import { path, assetsBaseUrl } from "../../../routes";
import {Button, Divider, Switch} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";

const Vienna_slide = (props) =>{
    const [user, setUser] = useState(props.cred);

    const temp = {
        id: 0,
        Header: "Namespace",
        Body: {
            file: "",
            imgURL: logo,
            elevators: [
                {
                    name: "E1_",
                    checked: false
                },
                {
                    name: "E2_",
                    checked: true
                },
                {
                    name: "E3_",
                    checked: false
                }
            ]
        }
    }
    const [idCount, setIdCount] = useState(1);
    const [groupid, setGroupid] = useState(1);
    const [currentID, setCurrentID] = useState(null);
    const [cards, setCards] = useState([])
    const [cardsNew, setCardsNew] = useState([])
    const [modalLoaded, setModalLoaded] = useState(false);
    const [modalVariant, setModalVariant] = useState(null);
    const [images, setImages] = useState([]);
    const [fileContent, setFileContent] = useState('');
    const [radioDown, setradioDown] = useState(0);
    const [radioUp, setradioUp] = useState(0);
    const [modalBodyUpdate,setmodalBodyUpdate]=useState({
        name:"",
        device:null,
        date:"2020-11-11 00:00:00",
        dateFrom:"2020-11-11 00:00:00",
        dateTo:"2020-11-11 00:00:00",
        room:"A-D"
    })
    const [modalBody, setModalBody] = useState({
        file: "",
        text: "testik",
        v1: false,
        v2: true,
        v3: true
    });
    const fetchDataCards = async (gr) => {
        try {
            const response = await axios.get(`${path}/getCardsV3?orgID=${props.cred.cOrganization_id}&group=${gr}`);
            console.log(response.data);
            // Optionally, update your UI to reflect the deletion
            setObje(response.data)
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }
    const fetchDataRadio = async (gr) => {
        try {
            const response = await axios.get(`${path}/getCardsV3Radio?groupRadio=${gr}`);
            console.log("RS",response.data[0].vienna_show);
            // Optionally, update your UI to reflect the deletion
           // setObje(response.data)
            if (gr == 5){
                response.data[0].vienna_show == 0? setradioDown(false):setradioDown(true)
            }
            if (gr == 6){
                response.data[0].vienna_show == 0? setradioUp(false):setradioUp(true)
            }
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }
    const updateRadio = async (kiosk) => {
        let tmp
        if (kiosk == 1){
            radioDown == true?tmp=0:tmp=1
        }
        if (kiosk == 2){
            radioUp == true?tmp=0:tmp=1
        }
        const rs = await axios.post(`${path}/updateReset/17`)
    }

    const setObje =  (x) =>{
        let fld=[]
        for(let i = 0;i<x.length;i++){
            const id = x[i].id
            try {
                let temp = {
                    id: id,
                    Header: x[i].description,
                    CreatedBy: x[i].username,
                    isVisible: x[i].isVisible !== false && x[i].isVisible !== 0,
                    Body: {
                        file: x[i].path,
                        //imgURL: `https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png`,//fileContent,
                        imgURL: assetsBaseUrl + x[i].path
                    }
                }
                fld.push(temp)
            } catch (error) {
                console.error('Fetching elevators Error:', error.message);
            }
        }
        console.log(fld)
        setCards([...fld])
    }

    const setCardVisibility = async (cardId, visible) => {
        setCards((prev) => prev.map((c) => (c.id === cardId ? { ...c, isVisible: Boolean(visible) } : c)));
        try {
            const orgId = props.cred?.cOrganization_id;
            const url = orgId ? `${path}/setCardVisibility/${cardId}?orgID=${encodeURIComponent(orgId)}` : `${path}/setCardVisibility/${cardId}`;
            const body = { isVisible: visible ? 1 : 0, orgID: orgId };
            try {
                await axios.put(url, body);
            } catch (putErr) {
                if (putErr?.response?.status === 404) await axios.post(url, body);
                else throw putErr;
            }
        } catch (e) {
            await fetchDataCards(groupid);
            const status = e?.response?.status;
            const data = e?.response?.data;
            if (status === 409 && data?.missingColumn) {
                alert(
                    `Cannot change visibility because database column is missing: ${data.missingColumn}\n\n` +
                    `${data.hint || 'Run the migration SQL on the production database.'}`
                );
            } else {
                alert('Failed to change visibility.');
            }
        }
    };
    const delete_hanler = (id) => {
        setCurrentID(id)
        setModalVariant(0)
        setModalLoaded(true)
    }
    const preview_handler = () =>{}
    const add_hanler = (id) => {
        setCurrentID(null)
        setModalVariant(1)
        setModalBody(null)
        setModalLoaded(true)
    }
    const modal_close_handler = (id) => {
        setCurrentID(null)
        setModalVariant(null)
        setModalLoaded(false)
        setModalBody(null)
    }
    const add_toCards_handler = (card) => {
        setCards([...cards, card])
        setIdCount(idCount + 1)
    }
    const delete_fnc = async (id) => {
        try {
            const orgId = props.cred?.cOrganization_id;
            const url = orgId ? `${path}/deleteRow/${id}?orgID=${encodeURIComponent(orgId)}` : `${path}/deleteRow/${id}`;
            await axios.delete(url);
            setCards((prev) => prev.filter((c) => c.id !== id));
        } catch (error) {
            console.error('Error deleting row:', error);
            await fetchDataCards(groupid);
        }
    }
    useEffect(()=>{
        console.warn("ajojda")
        fetchDataCards(1)
    },[])
    const changeTab_handler = (event) =>{
        const temp = event.target.value
//console.log(temp)
        setGroupid(temp)
        fetchDataCards(event.target.value)
        if ( event.target.value == 5 || event.target.value == 6){
            fetchDataRadio(event.target.value)
        }
    }
    const label = { inputProps: { 'aria-label': 'Switch demo' } };
    return <>
        <div className={classes.header}>
            <Button onClick={changeTab_handler} value={1} color={"primary"}
                    variant={`${groupid == 1 ? "contained" : "text"}`} disabled={modalLoaded}>Slides</Button>
            <div className={classes.line}/>
            <Button onClick={changeTab_handler} value={2} color={"primary"}
                    variant={`${groupid == 2 ? "contained" : "text"}`} disabled={modalLoaded}>Restaurant - Menu</Button>
            <div className={classes.line}/>
            <Button onClick={changeTab_handler} value={3} color={"primary"}
                    variant={`${groupid == 3 ? "contained" : "text"}`} disabled={modalLoaded}>Restaurant -
                Specialities</Button>
            <div className={classes.line}/>
            <Button onClick={changeTab_handler} value={4} color={"primary"}
                    variant={`${groupid == 4 ? "contained" : "text"}`} disabled={modalLoaded}>Bar - Menu</Button>
            <div className={classes.line}/>
            <Button onClick={changeTab_handler} value={5} color={"primary"}
                    variant={`${groupid == 5 ? "contained" : "text"}`} disabled={modalLoaded}>Full-size -
                Spodní</Button>
            <div className={classes.line}/>
            <Button onClick={changeTab_handler} value={6} color={"primary"}
                    variant={`${groupid == 6 ? "contained" : "text"}`} disabled={modalLoaded}>Full-size -
                Horní</Button>
        </div>
        <FormControlLabel control={<Switch defaultChecked />} label="Show Full-size Banner" />
        <div className={classes.cont}>
            {cards.map(x => {
                return <MediaS
                    typ={1}
                    key={x.id}
                    delete={delete_hanler}
                    body={x.Body}
                    text={x.Header}
                    id={x.id}
                    preview={preview_handler}
                    isVisible={x.isVisible}
                    onVisibilityChange={(v) => setCardVisibility(x.id, v)}
                />
        })}
        <AddMedia click={add_hanler}/>
        {modalLoaded &&
            <ModalView V={modalVariant} ModalBody={modalBody} close={modal_close_handler} add={add_toCards_handler}
                       addID={idCount} currentID={currentID} delFNC={delete_fnc} cred={user}
                       modalBodyUpdate={modalBodyUpdate} groupID={groupid}/>}

    </div>
        </>
}

export default Vienna_slide